export default __webpack_public_path__ + "static/media/centro_barrio_parque.572633c8.jpg";